export const searchBarMixin = {
  props: {
    initialQuery: {
      type: String,
      default: ''
    },
    inputClass: {
      type: String,
      default: ''
    },
    customPlaceholderText: {
      type: String,
      required: false
    },
    variant: {
      type: String,
      default: 'inputGroup'
    }
  },

  emits: ['search'],

  data() {
    return {
      inputId: 'location-search-query-input',
      query: this.initialQuery
    }
  },

  computed: {
    placeholderText() {
      if (this.customPlaceholderText !== undefined) {
        return this.customPlaceholderText
      } else {
        return this.i18n.t('public.local_search.search_label')
      }
    }
  },

  methods: {
    search() {
      this.$emit('search', this.query)
    }
  }
}
